import React from "react";

const Field = ({ label, value, onChange, type = "text", hint, textarea }) => (
  <div className="field">
    <label>{label}</label>
    {textarea ? (
      <textarea value={value || ""} onChange={(e) => onChange(e.target.value)} style={{ minHeight: 80 }} />
    ) : (
      <input type={type} value={value || ""} onChange={(e) => onChange(e.target.value)} />
    )}
    {hint && <span className="hint">{hint}</span>}
  </div>
);

export const phoneToHref = (phone) => {
  const digits = (phone || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("90")) return `+${digits}`;
  if (digits.startsWith("0")) return `+90${digits.slice(1)}`;
  return `+90${digits}`;
};

const SiteEditor = ({ site, onChange }) => {
  const set = (k) => (v) => onChange({ ...site, [k]: v });
  const setNested = (group, k) => (v) => onChange({ ...site, [group]: { ...(site[group] || {}), [k]: v } });
  const setHour = (i, k) => (v) => {
    const hours = [...(site.hours || [])];
    hours[i] = { ...hours[i], [k]: v };
    onChange({ ...site, hours });
  };

  return (
    <>
      <div>
        <h3>Duyuru şeridi</h3>
        <label className="switch mt-1">
          <input
            type="checkbox"
            checked={!!site.announcement?.enabled}
            onChange={(e) => setNested("announcement", "enabled")(e.target.checked)}
          />
          Duyuruyu göster
        </label>
        <div className="mt-2" style={{ display: "grid", gap: 12 }}>
          <Field label="Duyuru metni" value={site.announcement?.text} onChange={setNested("announcement", "text")} textarea />
          <Field label="Bağlantı (isteğe bağlı)" value={site.announcement?.link} onChange={setNested("announcement", "link")} hint="Örn. /hakkimizda" />
          <Field
            label="Açılış tarihi"
            type="date"
            value={site.announcement?.openingDate}
            onChange={setNested("announcement", "openingDate")}
            hint="Bu tarihten 30 gün sonra duyuru otomatik gizlenir."
          />
        </div>
      </div>

      <div>
        <h3>İletişim</h3>
        <div className="mt-1" style={{ display: "grid", gap: 12 }}>
          <Field
            label="Telefon (görünen)"
            value={site.phone}
            onChange={(v) => onChange({ ...site, phone: v, phoneHref: phoneToHref(v) })}
            hint={`Arama bağlantısı: ${site.phoneHref || "-"}`}
          />
          <Field label="WhatsApp numarası" value={site.whatsapp} onChange={set("whatsapp")} hint="Ülke koduyla, boşluksuz: 905xxxxxxxxx" />
          <Field label="E-posta" value={site.email} onChange={set("email")} type="email" />
        </div>
      </div>

      <div>
        <h3>Adres</h3>
        <div className="mt-1" style={{ display: "grid", gap: 12 }}>
          <Field label="Adres satırı 1" value={site.address?.line1} onChange={setNested("address", "line1")} />
          <Field label="Adres satırı 2" value={site.address?.line2} onChange={setNested("address", "line2")} />
          <Field label="Harita araması" value={site.address?.mapsQuery} onChange={setNested("address", "mapsQuery")} hint="Google Haritalar'da bu metin aranır." />
        </div>
      </div>

      <div>
        <h3>Çalışma saatleri</h3>
        <div className="mt-1" style={{ display: "grid", gap: 12 }}>
          {(site.hours || []).map((h, i) => (
            <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
              <Field label="Günler" value={h.days} onChange={setHour(i, "days")} />
              <Field label="Saat" value={h.time} onChange={setHour(i, "time")} />
            </div>
          ))}
        </div>
      </div>

      <div>
        <h3>Usta</h3>
        <div className="mt-1" style={{ display: "grid", gap: 12 }}>
          <Field label="Ad" value={site.founder?.name} onChange={setNested("founder", "name")} />
          <Field label="Unvan" value={site.founder?.title} onChange={setNested("founder", "title")} />
          <Field
            label="Tecrübe (yıl)"
            type="number"
            value={site.founder?.experienceYears}
            onChange={(v) => setNested("founder", "experienceYears")(Number(v))}
          />
        </div>
      </div>
    </>
  );
};

export default SiteEditor;
